export default __webpack_public_path__ + "static/media/cat-5-4.3b273cfb.png";